import multiguard from 'vue-router-multiguard';
import { checkAuth } from '@/router/_auth';
import { checkBankType } from '@/router/individual/_type';
import { checkPolicy } from '@/router/individual/_policy';

export default [{
	path: '/home/bes',
	name: 'bes',
	redirect: { name: 'myContracts' },
	meta: {
		title: 'Bireysel Emeklilik',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/Home.vue'),
	children: [
		{
			path: 'contracts',
			name: 'myContracts',
			meta: {
				title: 'Bireysel Emeklilik - Sözleşmelerim',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/contracts/Home.vue'),
		},
		{
			path: 'detail/:contract',
			name: 'besDetail',
			redirect: { name: 'besDetailSummary' },
			meta: {
				title: 'Poliçe Detay',
				layout: 'default'
			},
			beforeEnter: multiguard([checkPolicy]),
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/Home.vue'),
			children: [
				{
					path: 'summary',
					name: 'besDetailSummary',
					meta: {
						title: 'Plan Özeti',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/summary/Home.vue'),
				},
				{
					path: 'fund-actions',
					name: 'besDetailFund',
					meta: {
						title: 'Fon İşlemleri',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/fund/Home.vue'),
				},
				{
					path: 'payment-actions',
					name: 'besDetailPayment',
					meta: {
						title: 'Ödeme İşlemleri',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/payment/Home.vue'),
				},
				{
					path: 'bes-infos',
					name: 'besDetailInfos',
					redirect: { name: 'besDetailInfosInfo' },
					meta: {
						title: 'Sözleşme Bilgileri',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/info/Home.vue'),
					children: [
						{
							path: 'info',
							name: 'besDetailInfosInfo',
							meta: {
								title: 'Temel Bilgiler',
								layout: 'default'
							},
							component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/info/Info.vue'),
						},
						{
							path: 'payment-infos',
							name: 'besDetailInfosInfoPayment',
							meta: {
								title: 'Ödeme Bilgileri',
								layout: 'default'
							},
							component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/info/PaymentInfos.vue'),
						},
						{
							path: 'beneficiary-infos',
							name: 'besDetailInfosInfoBeneficiary',
							meta: {
								title: 'Lehtar Bilgisi',
								layout: 'default'
							},
							component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/info/Beneficiary.vue'),
						},
						{
							path: 'fund-infos',
							name: 'besDetailInfosInfoFund',
							meta: {
								title: 'Fon Bilgileri',
								layout: 'default'
							},
							component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/info/Fund.vue'),
						}
					]
				},
				{
					path: 'dynamic-forms',
					name: 'besDetailForms',
					meta: {
						title: 'Formlar',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/forms/Home.vue'),
				},
			]
		},
		{
			path: 'extra-contribution-payment/:contract',
			name: 'besExtraContributionPayment',
			meta: {
				title: 'Katkı Payı Ödeme',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/payment/ExtraContributionPayment.vue'),
		},
		{
			path: 'contribution-payment/:contract',
			name: 'besContributionPayment',
			meta: {
				title: 'Katkı Payı Ödeme',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/payment/ContributionPayment.vue'),
		},
		{
			path: 'change-fund-distribution/:contract/:type',
			name: 'besChangeFundDistribution',
			meta: {
				title: 'Fon Dağılımını Değiştir',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/fund/ChangeFundDistribution.vue'),
		},
		{
			path: 'befas-fund/:contract/:type',
			name: 'befasFund',
			meta: {
				title: 'BEFAS Fonları',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/fund/BefasFund.vue'),
		},
		{
			path: 'contribution-progress/:contract',
			name: 'besContributionProgress',
			meta: {
				title: 'Devlet Katkısı Hak Edişi Detayı',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/ContributionProgress.vue'),
		},
		{
			path: 'contribution-change/:contract',
			name: 'besContributionChange',
			meta: {
				title: 'Katkı Payı Değiştirme',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/detail/ContributionChange.vue'),
		},
		{
			path: 'calculation-tools',
			name: 'besCalculationTools',
			redirect: { name: 'besCalculationToolsPossibleAccumulationCalculation' },
			meta: {
				title: 'Bireysel Emeklilik - Hesaplama Araçları',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/calculation-tools/Home.vue'),
			children: [
				{
					path: 'possible-accumulation-calculation',
					name: 'besCalculationToolsPossibleAccumulationCalculation',
					meta: {
						title: 'Muhtemel Birikim Hesaplama',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/calculation-tools/PossibleAccumulationCalculation.vue'),
				},
				{
					path: 'contribution-calculation',
					name: 'besCalculationToolsContributionCalculation',
					meta: {
						title: 'Katkı Payı Hesaplama',
						layout: 'default'
					},
					component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/calculation-tools/ContributionCalculation.vue'),
				}
			]
		}
	]
},]